import { EpkModuleApiService } from '~packages/epk-front-shared/api-client';
import { RequestMethod } from '~packages/json-api/client';

export class SseApiService extends EpkModuleApiService {
  constructor() {
    super({
      className: 'SseApiService',
    });
  }
}

export class RpcApiService extends EpkModuleApiService {
  constructor() {
    super({
      className: 'RpcApiService',
    });
  }

  async listGet(params: any) {
    return await this._sendRequest(
      `/tasks/`,
      params,
      { method: RequestMethod.GET },
      { method: 'listGet' }
    );
  }

  async delete(app_hash_md5: string) {
    return await this._sendRequest(
      `/tasks/md5/${app_hash_md5}`,
      undefined,
      { method: RequestMethod.DELETE },
      { method: 'delete' }
    );
  }

  async check(app_hash_md5: string, task_id: string) {
    return await this._sendRequest(
      `/tasks/result/md5/${app_hash_md5}?task_id=${task_id}`,
      undefined,
      { method: RequestMethod.GET },
      { method: 'check' }
    );
  }

  async storageAuth() {
    return await this._sendRequest(
      `/tasks/storage_auth`,
      undefined,
      { method: RequestMethod.GET },
      { method: 'storageAuth' }
    );
  }
}
